import { useParams } from "react-router-dom";
import { useGetByPrePlanting } from "../../api/scouting";
import { InfoCard } from "../../components/cards/info-card";
import { MetaDataCard } from "../../components/shared/MetaDataCard";

const PrePlantingDetailPage = () => {
  const { id } = useParams();
  const prePlantingId = id ? Number(id) : undefined;
  const { data: prePlanting } = useGetByPrePlanting(prePlantingId as number);

  const preplantingDetail = prePlanting?.data?.data;

  const statData = [
    {
      title: "Date",
      value: preplantingDetail?.date,
    },
    {
      title: "Field Conditions",
      value: preplantingDetail?.fieldConditions,
    },
    {
      title: "Soil Analysis",
      value: preplantingDetail?.soilAnalysis,
    },

    {
      title: "Land Size",
      value: preplantingDetail?.landSize,
    },
    {
      title: "Preparation Rating (%)",
      value: preplantingDetail?.preparationRating,
    },
  ];

  return (
    <div className="min-h-screen bg-white py-8 mt-6">
      {/* Main Content */}
      <div className="p-6 space-y-8">
        {/* Field Assessment Section */}
        <section className="p-6 rounded-2xl border border-[#EBEBEB] gap-[10px]">
          <h2 className="text-base font-semibold text-gray-800 mb-4 pb-2">
            Field Assessment
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-y-4 gap-x-6 mb-4">
            {statData.map((stat, index) => (
              <InfoCard title={stat.title} value={stat.value} key={index} />
            ))}
          </div>
        </section>

        {/* Recommendations Section */}
        <section className="p-6 rounded-2xl border border-[#EBEBEB] gap-[10px]">
          <div className="text-sm ">
            <p className="text-[#000000]/50">Recommendations</p>
            <p className="text-[#000000]">
              {preplantingDetail?.recommendations}
            </p>
          </div>
        </section>

        {/* Metadata Section */}
        <MetaDataCard
          metadata={preplantingDetail}
          title="Metadata"
          cardBackgroundColor="white"
        />
      </div>
    </div>
  );
};

export default PrePlantingDetailPage;
